import React from 'react';

import SuccessView from '../../views/dashboard/SuccessView.js';
import * as Auth from '../../services/Auth.Service.js';
import * as Services from '../../services/Dashboard.Service.js';


export class SuccessComponent extends React.Component {

	/**
	 * Class constructor.
	 * @argument {object} props
	 */
	constructor(props) {
		super(props);


	this.state = {

		
    };
	}

	componentWillMount() {

	}

	/**
	 * Render the component.
	 */
	render() {
		return (
			<div>
				<SuccessView
					results={this.state.results}
					SearchTerm={this.SearchTerm}
					SelectFaver={this.SelectFaver}
					search_key={this.state.search_key}
				/>
			</div>
			);
	}

}



// WEBPACK FOOTER //
// ./src/client/components/dashboard/SuccessComponent.js